import { render, staticRenderFns } from "./WeeklyOverview.vue?vue&type=template&id=c0cc1010"
import script from "./WeeklyOverview.vue?vue&type=script&lang=js"
export * from "./WeeklyOverview.vue?vue&type=script&lang=js"
import style0 from "./WeeklyOverview.vue?vue&type=style&index=0&id=c0cc1010&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports